import React from "react"

export default () => (
    <footer className="footer u-fill--dark">
        <div className="container">
            <h2 className="heading heading--large u-color--primary cursor cursor--dark">Say hey</h2>
            <p>
                I’m <a className="link" href="http://twitter.com/heyits0livia">@heyits0livia</a>.
                Say hey at <a className="link" href="mailto:olivia@heyitsolivia.com">olivia@heyitsolivia.com</a>.
            </p>
        </div>
    </footer>
)
